export default __webpack_public_path__ + "static/media/desktopFix.380d3977.jpg";